import { createContext, useContext } from "react";
import { Message, SendFile } from "../models/Message";
import { RoomItem } from "../models/RoomItem";
import { FilterType } from "../models/local/Types";
import { Workspace } from "../models/Workspace";
import { Room } from "../models/Room";
import { Soribot } from "../models/Soribot";
import { EnterType } from "../ui/rooms/right-menu/RoomFilesModal";
import { RoomCall } from "../models/RoomCall";
export type RightMenuList = 'filters' | 'links' | 'members' | 'none';

export type IAppUIContext = {
  filter: FilterType
  setFilter: (t: FilterType) => void,
  iframeItem: RoomItem | null
  setIframeItem: (item: RoomItem | null) => void,
  messageToShow: Message | null
  setMessageToShow: (item: Message | null) => void,
  workspaces: Workspace[]
  setWorkspaces: (list: Workspace[]) => void,
  rooms: Room[]
  setRooms: (list: Room[]) => void,
  soribots: Soribot[]
  setSoribots: (list: Soribot[]) => void,
  uploadFiles: SendFile[]
  setUploadFiles: (files: SendFile[]) => void,
  showFilesModal: boolean
  setShowFilesModal: (showFilesModal: boolean) => void,
  enterType: EnterType
  setEnterType: (enterType: EnterType) => void,
  isMobileMenuOpen: boolean
  setIsMobileMenuOpen: (open: boolean) => void,
  activeCalls: Map<string, RoomCall>,
  setActiveCalls: (calls: Map<string, RoomCall>) => void,
  roomsLoaded: boolean,
  setRoomsLoaded: (loaded: boolean) => void
}
export const AppUIContext = createContext<IAppUIContext>({
  filter: 'none', setFilter: () => { },
  iframeItem: null, setIframeItem: () => { },
  messageToShow: null, setMessageToShow: () => { },
  workspaces: [], setWorkspaces: () => { },
  rooms: [], setRooms: () => { },
  soribots: [], setSoribots: () => { },
  uploadFiles: [], setUploadFiles: () => { },
  showFilesModal: false, setShowFilesModal: () => { },
  enterType: 'link', setEnterType: () => { },
  isMobileMenuOpen: false, setIsMobileMenuOpen: () => { },
  activeCalls: new Map<string, RoomCall>(), setActiveCalls: () => { },
  roomsLoaded: false, setRoomsLoaded: () => { }
})
export const useAppUIContext = () => useContext(AppUIContext);